import React from "react";
import Bookmark from '@mui/icons-material/CheckCircleOutline';
import IconButton from '@mui/material/IconButton';
import Chip from "@mui/material/Chip";
export function DocumentSinglePageDocPlace(props) {

    const setCurrentDocument = (page) => {
        props.document(page);
    };
    return (
        <>



           { (props.show === props.index) && (
           
            <div
                key={props.index}
                style={{ width: '100%', position: 'relative' }}
                onClick={() => setCurrentDocument(props.page)}

            >



                <img className="docImage" title={`Click to run OCR for ${props.page.fileName}`} src={props.page.thumbnail} alt={props.page.fileName} />
                <div className="documentTitle" ><span className="number" >#{props.page.parentIndex+1}</span> - {props.page.originalFileName}</div>
                <div style={{ marginTop: 6, display: "flex", justifyContent: "center" }}>
                    {props.ocrDone ? (
                        <Chip size="small" color="success" label="OCR completed" />
                    ) : (
                        <Chip size="small" variant="outlined" label="Needs OCR" />
                    )}
                </div>
                {
                    (props.ocrDone) &&
                    <IconButton color="success" sx={{ position: 'absolute', marginTop: '-140px', marginLeft: '-24px' }} aria-label="OCR" title="OCR has been applied to this document.">
                        <Bookmark />
                    </IconButton>


                }
            </div>

            )}

        </>
    )
}

export default DocumentSinglePageDocPlace

